import React from 'react';
import '../css/App.css';
import { getUserData } from '../actions/userActions';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import YouTube from "react-youtube"; // requires a loader
import TweetEmbed from 'react-tweet-embed';
import { Props, State } from "./IApp";
import GlobalHelper from "../helpers/globalHelper";

export class App extends React.Component<Props, State> {
    private vidRef: any;
    private autoplay_video: boolean;
    private touchStartPos: number = 0;
    private touchStopPos: number = 0;
    private touchMinLength: number = 50;
    private touchStartPosY: number = 0;
    private touchStopPosY: number = 0;

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            step: 1,
            config: {
                mainColor: ' #fcd000',
                secondColor: '#d267e0',
                appBackground: '#20294e',
                buttons: [],
                video_first: true,
                disable_page: false
            },
            isPlaying: false,
            selectedPopupData: null,
            showPopa: false,
            showPlaybutton: true,
            currentSlide: 1,
            postsView: 'grid'
        };

        this.autoplay_video = false
    }

    componentDidMount() {
        const username = window.location.pathname.replace("/i/", "");
        getUserData(username, (response) => {
            if (response) {
                this.setState({ data: response }, () => {
                    document.title = response.name + " - Humanz";
                    this.loadUserSettings();
                });

                //remove, just debugging
                console.log(this.state.data);

                if (this.state.data?.intro_video && this.autoplay_video) {
                    this.playVideo().then(res => {
                        this.setState({ showPlaybutton: false })
                    })
                }

                if (!this.state.data?.intro_video) {
                    this.setState({ step: 2 })
                }

                if(!this.state.data?.linked_posts || !this.state.data?.linked_posts.length){
                    let linkedPosts = [];
                    for(let i=0; i<6; i++){
                        linkedPosts.push({post_thumbnail:''});
                    }
                    // @ts-ignore
                    this.state.data.linked_posts = linkedPosts;
                    // @ts-ignore
                    this.setState({})
                }
            }else{
                window.location.href='https://www.humanz.com/404';
            }
        })
    }

    loadUserSettings = () => {
        let tempstate = { ...this.state };
        if (tempstate.data && tempstate.config && tempstate.data.external_page_settings) {
            let s = tempstate.data.external_page_settings;
            tempstate.config.mainColor = s.primary_color;
            tempstate.config.secondColor = s.secondary_color;
            tempstate.config.buttons = s.buttons;
            // // todo: remove demo data
            // tempstate.config.buttons = [{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},{id:1,order:1,label:"Hello this is a test",link:"http://ynet.co.il"},]
            tempstate.config.video_first = s.video_first;
            tempstate.config.disable_page = s.disable_page;
            this.setState(tempstate, () => {
                // do after user settings are applied
                // @ts-ignore
                if (this.state.config) {
                    if (!this.state.config.video_first) {
                        this.setState({ step: 2, showPlaybutton: false });
                    }
                    if (this.state.config?.buttons && this.state.config?.buttons?.length) {
                        // @ts-ignore
                        this.state.config.buttons.sort((a, b) => (a.position > b.position))
                    }
                }
            });
        }
    };

    stopVideo = () => {
        if (!this.vidRef) return;
        try {
            this.vidRef.pause().then(() => {
                this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: true });
            }).catch((e: any) => {
                this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: true });
                console.log(e, "Browser doesnt support playing on load");
            });
        } catch (e) {
            console.log("Browser doesnt support playing on load");
            this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: true });
        }
    }

    renderPost = (post: string, selectedSocial: string) => {
        if (selectedSocial === 'ig_post')
            return (<div className="blurable-frame">
                <iframe
                    src={"https://www.instagram.com/p/" + post + "/embed/captioned"}
                    width="100%" height="400" frameBorder="0" scrolling="no"></iframe>
            </div>);

        if (selectedSocial === 'ig_story')
            return (
                <div className="story-image-container">
                    {post ?
                        <img className="blurable" src={post} />
                        :
                        <div className="empty-image" />
                    }
                </div>);
        if (selectedSocial === 'tw_tweet')
            return (<div className="blurable-frame">
                <TweetEmbed id={post} />
            </div>);

        if (selectedSocial === 'yt_video')
            return (
                <div className="blurable-frame" style={{
                    display: 'inline-block',
                    width: '100%',
                    overflow: 'hidden',
                    marginTop: '10px'
                }}>
                    <YouTube
                        videoId={post}
                        opts={{ width: '100%' }}
                    />
                </div>
            );

        if (selectedSocial === 'tk_video')
            return (<div className="blurable-frame">
                <iframe style={{
                    display: 'block',
                    width: '100%',
                    height: 'calc(100vh - 49px)',
                    overflow: 'hidden'
                }}
                    src={"https://www.tiktok.com/embed/" + post}
                    frameBorder={"0"}
                    allow={"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"} />
            </div>);
    };

    nextSlide = () => {
        if (this.state.currentSlide === 1) {
            this.stopVideo();
        }
        if (this.state.data && this.state.data.linked_posts && Object.keys(this.state.data.linked_posts).length) {
            this.setState((state) => ({
                // @ts-ignore
                currentSlide: state.currentSlide + 1 > Object.keys(this.state.data.linked_posts).length ? 0 : state.currentSlide + 1,
            }));
        }
    };

    prevSlide = () => {
        if (this.state.data && this.state.data.linked_posts && Object.keys(this.state.data.linked_posts).length) {
            this.setState((state) => ({
                // @ts-ignore
                currentSlide: state.currentSlide - 1 > Object.keys(this.state.data.linked_posts).length ? 0 : state.currentSlide - 1,
                isPlaying: state.currentSlide === 1
            }));
        }
    };

    renderPopa = (selectedPopupData: any) => {
        // if(this.state.selectedPopupData){
        return (<div className={'popa' + (this.state.showPopa ? ' swing-in-bottom-fwd ' : ' slide-out-left')}>
            {this.state.selectedPopupData && <>
                <i className="post-loader rotate-center fas fa-circle-notch" />
                <div className="close" onClick={() => {
                    this.setState({ showPopa: false });
                    setTimeout(() => {
                        this.setState({ selectedPopupData: null });
                    }, 1000);
                }}><i className="far fa-times-circle" /></div>
                <div className="post">
                    {this.renderPost(selectedPopupData.post, selectedPopupData.selectedSocial)}
                </div>
            </>}
        </div>);
    };

    playVideo = async () => {
        if (this.vidRef) {
            this.setState({ isPlaying: true });
            try {
                this.vidRef.play().then(() => {
                    this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: false });
                }).catch((e: any) => {
                    console.log(e, "Browser doesnt support playing on load");
                });
            } catch (e) {
                console.log("Browser doesnt support playing on load");
            }
        }
    };

    getVideo = (elem: any) => {
        this.vidRef = elem;
    };

    renderRipple = () =>{
        return this.state.step ===1 && <div className='ripple-background'>
            <div className='circle-animated xxlarge shade1'></div>
            <div className='circle-animated xlarge shade2'></div>
            <div className='circle-animated large shade3'></div>
            <div className='circle-animated mediun shade4'></div>
            <div className='circle-animated small shade5'></div>
        </div>
    }

    renderBackground = () => {
        let circleAnimation = this.state.step === 2 ? 'circle-animation' : '';
        if (!this.state.data || !this.state.config) return;
        // for debug, remove
        // this.state.data.intro_video = '';
        let isWide = this.state.data?.intro_video_ratio > 0.7;
        if (this.state.data?.intro_video && this.state.data.intro_video !== '') {
            return <div className={"background " + circleAnimation}>
                <video style={{height:this.state.data?.intro_video_ratio && isWide?window.innerWidth*(1/this.state.data?.intro_video_ratio):'100%'}} playsInline loop autoPlay={false} ref={this.getVideo} controls={false} className={isWide?'border':''}
                    src={decodeURIComponent(this.state.data.intro_video)} />
                {this.renderRipple()}
            </div>
        }
        if (this.state.data?.intro_thumbnail) {
            return <div className={'background ' + circleAnimation}
                        style={{ backgroundImage: ('url(' + this.state.data.intro_thumbnail + ')') }} >{this.renderRipple()}</div>
        }
        if (this.state.data?.image) {
            return <div className={'background background-blur ' + circleAnimation}
                style={{ backgroundImage: ('url(' + this.state.data.image + ')') }} >{this.renderRipple()}</div>
        }
        return <div className={'background ' + circleAnimation} style={{ backgroundColor: this.state.config.mainColor }} >{this.renderRipple()}</div>
    };


    renderSocialCounters = () => {
        if (!this.state.data || !this.state.data.social_data) return null;
        return <div className={'social-counter slide-left'}>
            {Object.keys(this.state.data?.social_data).map((i: any) => {
                console.log(this.state.data?.social_data, "social");
                return this.state.data?.social_data[i] ? (
                    <a href={GlobalHelper.openSocialPage(i, this.state.data?.social_data[i].username)} target="_blank"
                        key={'social_c_' + i} className={'single-social-counter'}>
                        {/*<div className="followers">{this.formatNumber(this.state.data?.social_data[i]?.followers)}</div>*/}
                        <div className="social-icon"><i className={"fab " + (GlobalHelper.getSocialIcon(i))} /></div>
                    </a>) : '';
            })}
        </div>
    };

    renderCustomButtons = () => {
        if (!this.state.data || !this.state.data.external_page_settings || !this.state.config || !this.state.config.buttons.length) return null;
        return <div className="custom_buttons">
            {/* {this.state.step === 2 &&
                <div className={"second-buble scale-in-right"} style={{ backgroundColor: this.state.config?.secondColor }} />} */}
            <div style={{ textAlign: 'center' }}>
                {this.state.config.buttons.map((b, i) => {
                    // @ts-ignore
                    return (<>
                        <div style={{ background: 'white', padding: '1px 6px', borderRadius: 6, margin: '15px 10px ', boxShadow: '2px 2px 5px 5px rgba(0,0,0,0.1)' }}>
                            <a style={{ color: this.state.config?.secondColor, margin: '10px 0px', textAlign: 'center', paddingRight: 0 }} target={"_blank"} id={b.id} href={b.link}>
                                <strong>{b.label}</strong>
                            </a>
                        </div>
                    </>)

                })}
            </div>
        </div>
    };

    nextStep = () => {
        this.stopVideo();
        if (this.state.step > 3) return;
        window.scroll(0, 0);
        if (this.state.step > 2) {
            this.nextSlide()
        } else {
            this.setState({ step: this.state.step + 1 });
        }
    };

    prevStep = () => {
        if (this.state.step < 2) return;
        if (this.state.step > 3) {
            this.prevSlide()
        } else {
            this.setState({ step: this.state.step - 1 });
        }
    };

    onMouseWheel = (e: any) => {
        return;
        const direction = e.wheelDelta || e.deltaY
        if (direction > 0) {
            this.prevStep()
        } else {
            this.nextStep()
        }
    }

    onTouchStart = (e: any) => {
        // e.preventDefault()
        if (
            e.type === 'touchstart' ||
            e.type === 'touchmove' ||
            e.type === 'touchend' ||
            e.type === 'touchcancel'
        ) {
            var touch = e.touches[0] || e.changedTouches[0]
            this.touchStartPos = touch.pageX
            this.touchStartPosY = touch.pageY
        }
    }

    onTouchEnd = (e: any) => {
        // e.preventDefault()
        if (
            e.type === 'touchstart' ||
            e.type === 'touchmove' ||
            e.type === 'touchend' ||
            e.type === 'touchcancel'
        ) {
            var touch = e.touches[0] || e.changedTouches[0];
            this.touchStopPos = touch.pageX
            this.touchStopPosY = touch.pageY
        }
        if (this.state.step === 1 && this.touchStartPosY > this.touchStopPosY + this.touchMinLength) {
            this.nextStep()
        }
        if (this.touchStartPos + this.touchMinLength < this.touchStopPos) {
            this.prevStep()
        }
        // else if (this.touchStartPos > this.touchStopPos + this.touchMinLength) {
        //     this.nextStep()
        // }
    }

    render() {
        const { data } = this.state;
        if (!this.state.data) return null;
        return (
            <div className="App"
                onTouchStart={this.onTouchStart}
                onTouchEnd={this.onTouchEnd}
                onWheel={this.onMouseWheel}
                style={{ background: (this.state.step === 1 ? this.state.config?.appBackground : this.state.config?.mainColor) }}>
                <section style={{ minHeight: window.innerHeight}}>
                    {this.state.step !== 1 && <div className={"second-background-circle scale-in-center " + (this.state.step > 2 ? 'full' : '')}
                        style={{
                            opacity:(this.state.step > 1)?1:0,
                            animationDelay: '0.7s',
                            background: (this.state.step > 2 ? this.state.config?.secondColor : 'transparent')
                        }} >
                    </div>}
                    {/*step 1*/}
                    {((this.state.data?.intro_video && this.state.data.intro_video !== '') && this.state.showPlaybutton && this.state.step ===1) &&
                        <div className="play-button" onClick={() => this.playVideo()}><i className="fas fa-play" /></div>}
                    <div className="scrollup">
                        {(this.state.step > 1 && this.state.data?.intro_video) && <div className="back" onClick={() => this.prevStep()}>
                            <i className={"far fa-arrow-alt-circle-left"} />
                        </div>}
                        {(this.state.step < 2) &&
                            // {(this.state.step < 2 || (this.state.step === 2 && this.state.postsView !== 'carousel')) &&
                            <div className="forward" onClick={() => this.nextStep()}>
                                {
                                    <i className={"far " + (this.state.step < 2 ? 'fa-arrow-alt-circle-up' : 'fa-arrow-alt-circle-right')} />}
                            </div>}
                    </div>
                    {this.state.step < 3 && this.renderBackground()}
                    <section className={'full-section'} style={{ position: "absolute", pointerEvents: "none" }}>
                        <div className="user-details">
                            <div className="col-small slide-bottom">
                                <div style={this.state.step > 1 ? { position: "absolute" } : {}}
                                    className={'username ' + ((this.state.step > 2 ? ' slide-out-left ' : '') + (this.state.step === 1 && ' hue'))}>
                                    {data?.username || data?.name}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/*step 2*/}

                    <div className="about-wrapper">
                        {(this.state.step > 1) && <section className={'full-section more-details'} style={this.state.step < 2 ? { position: "absolute" } : {}}>
                            <div className="step2-header-container">
                                <div className="humanz-logo fadein"><a href="https://www.humanz.com/creators/"><img src={"images/logo.svg"} width={120}
                                                                                                          alt="" /></a>
                                </div>
                                <img onClick={this.prevStep} className={("user-image scale-in-center "+(this.state.data.intro_video?"color-change-4x":""))} alt="user" src={data?.image} />
                            </div>
                            <div className={"about" + (this.state.step > 2 ? ' slide-out-right' : ' slide-left-m')}
                                style={{ animationDelay: '0s' }}>
                                <div className="about-bar slide-in-bottom" />
                                <strong>{data?.name}</strong> <br />
                                <span className="bio-text" dangerouslySetInnerHTML={GlobalHelper.addLinks(data?.about)}/>
                                {this.renderCustomButtons()}
                                <div className="vertical-sep"/>
                                {GlobalHelper.renderHumanzAcademyBadge(this.state.data.academy_badge)}
                            </div>
                        </section>}
                        <div
                            className={"social-counters" + (this.state.step > 1 ? ' smaller' : '') + (this.state.step === 3 ? ' top' : '')}>
                            {this.renderSocialCounters()}
                        </div>
                        {/*step 3*/}
                        {this.renderPosts()}
                    </div>
                </section>

                {/*popup*/}
                {this.renderPopa(this.state.selectedPopupData)}
            </div>
        );
    }

    renderPosts = () => {
        if (this.state.step !== 2) return;
        let carusel = <section className="full-section posts tilt-in-fwd-bl">
            <div className="small-username">{this.state.data ? this.state.data.name : ''}</div>
            {/*posts carousel*/}
            {this.state.data?.linked_posts && <Carousel selectedItem={this.state.currentSlide} onClickItem={(i) => {
                let post = this.state.data?.linked_posts[i];
                this.setState({
                    showPopa: true,
                    selectedPopupData: { post: post.media_id, selectedSocial: post.post_type }
                })
            }} className={""} showIndicators={false} centerMode={true} swipeable={true} infiniteLoop={true}
                showStatus={false} emulateTouch={true} showThumbs={false}>
                {this.state.data?.linked_posts.map((post, i) => {
                    if (post.thumbnail)
                        return (<div className={"single-post"} key={'post_' + i}>
                            <img src={post.thumbnail} />
                        </div>);
                    return this.renderEmptyImage(post, i);
                })}
            </Carousel>}
        </section>;

        let posts = <section className="posts tilt-in-fwd-bl">
            {/*<div className="small-username">{this.state.data ? this.state.data.name : ''}</div>*/}
            {this.state.data?.linked_posts && <div className={"posts-grid"}>
                {this.state.data?.linked_posts.map((post, i) => {
                    if (post.thumbnail)
                        return (<div className={"single-post tilt-in-fwd-bl"}
                            style={{ animationDelay: (Math.random() * (0.5 - 0.1 + 1) + 0.5) + 's' }}
                            key={'post_' + i} onClick={() => {
                                let post = this.state.data?.linked_posts[i];
                                this.setState({
                                    showPopa: true,
                                    selectedPopupData: { post: post.media_id, selectedSocial: post.post_type }
                                })
                            }}>
                            <img src={post.thumbnail} />
                        </div>);
                    return this.renderEmptyImage(post, i);
                })}
            </div>}
        </section>;

        // We can select between posts grid view or carousel view;
        // return carusel;
        return this.state.postsView === 'carousel' ? carusel : posts;
    };

    renderEmptyImage = (post: any, i: number) => {
        if (post.caption) {
            return <div className={"single-post tilt-in-fwd-bl"}
                style={{ animationDelay: (Math.random() * (0.3 - 0.1 + 1) + 0.3) + 's' }}>
                <div key={'post_' + i} className={'color-change-4x caption'}
                    style={{ animationDelay: (Math.random() * (4 - 0.1 + 1) + 0.1) + 's' }}>
                    <div className="caption">{post.caption}</div>
                    <div className="social-icon"><i className={"fab " + (GlobalHelper.getSocialIcon(post.post_type))} /></div>
                </div>
            </div>
        }
        return <div key={'post_' + i} style={{ animationDelay: (Math.random() * (4 - 0.1 + 1) + 0.1) + 's' }} className={'color-change-4x empty-image single-post'}>
            <i className="fas fa-images" /> <span>Post coming soon!</span></div>;
    }
}

export default App;
